import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "addTime"
  }

  return (
    <>
      <Head>
        <title>{`Special Free Shipping on Select Products | BestDeals.co.nz`}</title>
        <meta name="keywords" content={`best deals nz, best deals, bestdeals nz, bestdeals, appliance, furniture`}></meta>
        <meta name="description" content={`Discover select products with free shipping at Bestdeals.co.nz! Enjoy savings on shipping costs with our special offers. Browse eligible products today!`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout >
        <FeaturedSection type="free-shipping" defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}